import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  BankDetailsList: { loading: false, data: null, error: null },
  BankDetailsCreate: { loading: false, data: null, error: null },
  BankDetailsUpdate: { loading: false, data: null, error: null },
};

export const BankDetailsSlice = createSlice({
  name: "bankdetails",
  initialState,
  reducers: {
    fetchBankDetailsListRequest: (state, action) => {
      state.BankDetailsList.loading = true;
      state.BankDetailsList.error = null;
    },
    fetchBankDetailsListSuccess: (state, action) => {
      state.BankDetailsList.data = action.payload;
      state.BankDetailsList.loading = false;
      state.BankDetailsList.error = null;
    },
    fetchBankDetailsListFailure: (state, action) => {
      state.BankDetailsList.data = null;
      state.BankDetailsList.loading = false;
      state.BankDetailsList.error = action.payload;
    },
    BankDetailsCreateRequest: (state, action) => {
      state.BankDetailsCreate.loading = true;
      state.BankDetailsCreate.error = null;
    },
    BankDetailsCreateSuccess: (state, action) => {
      state.BankDetailsCreate.data = action.payload;
      state.BankDetailsCreate.loading = false;
      state.BankDetailsCreate.error = null;
      state.BankDetailsList = addNewBankDeatailsSuccess(action.payload, {
        ...state.BankDetailsList,
      });
    },
    BankDetailsCreateFailure: (state, action) => {
      state.BankDetailsCreate.data = null;
      state.BankDetailsCreate.loading = false;
      state.BankDetailsCreate.error = action.payload;
    },
    BankDetailsUpdateRequest: (state, action) => {
      state.BankDetailsUpdate.loading = true;
      state.BankDetailsUpdate.error = null;
    },
    BankDetailsUpdateSuccess: (state, action) => {
      state.BankDetailsUpdate.data = action.payload;
      state.BankDetailsUpdate.loading = false;
      state.BankDetailsUpdate.error = null;
      state.BankDetailsList = updateBankDetailsSuccess(action.payload, {
        ...state.BankDetailsList,
      });
    },
    BankDetailsUpdateFaliure: (state, action) => {
      state.BankDetailsUpdate.data = null;
      state.BankDetailsUpdate.loading = false;
      state.BankDetailsUpdate.error = action.payload;
    },
  },
});
function addNewBankDeatailsSuccess(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}
function updateBankDetailsSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((target) => {
    if (target._id !== dataToUpdate._id) return target;
    return { ...target, ...dataToUpdate };
  });
  return state;
}

export const {
  fetchBankDetailsListRequest,
  fetchBankDetailsListSuccess,
  fetchBankDetailsListFailure,
  BankDetailsCreateRequest,
  BankDetailsCreateSuccess,
  BankDetailsCreateFailure,
  BankDetailsUpdateRequest,
  BankDetailsUpdateSuccess,
  BankDetailsUpdateFaliure,
} = BankDetailsSlice.actions;

export const getBankDetailsSliceListState = (state) =>
  state.bankdetails?.BankDetailsList;
export const getBankDetailsSliceCreateState = (state) =>
  state.bankdetails?.BankDetailsCreate;
export const getBankDetailsSliceUpdateState = (state) =>
  state.bankdetails?.BankDetailsUpdate;

export default BankDetailsSlice.reducer;
